import React from "react";
import { Select } from "antd";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";

export const PaginationSelect = ({ children, suffixIcon, ...props }) => {
  const formattedChildren = React.Children.map(children, (child) => {
    if (!child) return child;
    return React.cloneElement(child, {
      children: `${child.props.value}/Page`,
    });
  });

  return (
    <Select
      {...props}
      size="small"
      suffixIcon={
        suffixIcon || (
          <ChevronIcon className="rotate-90 stroke-dark-gray w-2.5 h-2.5" />
        )
      }
    >
      {formattedChildren}
    </Select>
  );
};
PaginationSelect.Option = Select.Option;

export const customShowTotal = (total, range) => {
  if (!total || total === 0) return "Showing 0 of 0";
  return `Showing ${range[0]}-${range[1]} of ${Number(total || 0).toLocaleString()}`;
};

export const getCustomPaginationProps = ({
  current,
  pageSize,
  total,
  onChange,
  onShowSizeChange,
  pageSizeOptions = ["10", "20", "50", "100"],
  ...rest
} = {}) => ({
  current,
  pageSize,
  total: Number(total || 0),
  showSizeChanger: true,
  pageSizeOptions,
  selectComponentClass: PaginationSelect,
  showTotal: customShowTotal,
  itemRender: (page, type, originalElement) => (
    <CustomPagination
      current={page}
      type={type}
      originalElement={originalElement}
      totalRecords={Number(total || 0)}
    />
  ),
  onChange,
  onShowSizeChange,
  ...rest,
});

const CustomPagination = ({ current, type, originalElement, totalRecords }) => {
  const lastPage = totalRecords / current;

  if (type === "prev" && current === 0) {
    return (
      <button
        type="button"
        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
        style={{
          pointerEvents: "none",
        }}
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "prev" && current > 0) {
    return (
      <button
        type="button"
        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "next" && lastPage <= 10) {
    return (
      <button
        type="button"
        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
        style={{ pointerEvents: "none" }}
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "next") {
    return (
      <button
        type="button"
        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  return originalElement;
};

export default CustomPagination;
